module.exports = __webpack_public_path__ + "static/media/sword.05f1743.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/sword.mp3
// module id = CfcD
// module chunks = 5